import { defineMessages } from 'react-intl';

export default defineMessages({
  heading: {
    id: 'legalInfo_heading',
    defaultMessage: 'Informace o zpracování osobních údajů',
  },
});
